import moment from 'moment';
import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { RequestDict } from '../../../../components/dictionaries/RequestStatus';
import HttpService from '../../../../services/HttpService';
import SpecificFormDetails from '../SpecificFormDetails';

function SmartSpecificFormDetails() {
  const params = useParams<{ id: string }>();
  const { t } = useTranslation();
  const [formValues, setFormValues] = React.useState<any>([]);
  const [applicationDetails, setApplicationDetails] = React.useState<any>([]);
  const [formTitle, setFormTitle] = React.useState<string>('');
  const [id, setId] = React.useState<string>('');
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const basic_info = [
    [{
      name: 'id',
      value: id
    },
    {
      name: t('Αρμόδια Οργανική Μονάδα'),
      value: applicationDetails?.form_form_submissions?.form_form?.usr_administrative_unit?.descr
    },
    {
      name: t('Τομέας'),
      value: applicationDetails?.appl_section?.descr
    }],
    [{
      name: t('Αριθμός Πρωτοκόλλου'),
      value: '' || '-'
    },
    {
      name: t('Λογαριασμός Αιτούντα'),
      value: [applicationDetails?.usr_users_appl_applications_applicant_idTousr_users?.first_name,
        applicationDetails?.usr_users_appl_applications_applicant_idTousr_users?.last_name].join(' ') 
    }
    ],
    [
      {
        name: t('Ημερομηνία Υποβολής'),
        value: moment(applicationDetails?.date_created).format('DD/MM/YYYY HH:mm')
      },
      {
        name: t('Κατάσταση'),
        value: RequestDict[applicationDetails?.appl_status?.descr]
      }]];

  const fetching = async () => {
    try {
      const resp = await HttpService.getAxiosClient().get(`/forms/public/applications/${params.id}`);
      setFormTitle(resp.data?.appl_title_naming?.title);

      document.title= t(resp.data?.appl_title_naming?.title);

      setFormValues(resp.data?.form_form_submissions?.form_structure);
      setApplicationDetails(resp.data);
      
      setId(resp.data?.id);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      enqueueSnackbar(t('Παρουσιάστηκε κάποιο σφάλμα'), { variant: 'error' });
    }
  };
  useEffect(() => {
    fetching();
  }, []);

  return (<>
    
    <SpecificFormDetails
      basic_info={basic_info}
      formTitle={formTitle}
      formValues={formValues}
      isLoading={isLoading}

    />

  </>);
}

export default SmartSpecificFormDetails;